<template lang="html">
  <div>




    <div v-for="(step, idx) in stepWithOffset" :key="'s'+idx" class="note_box" :class="getBackgroundColor(idx, step)">
      <span v-if="data[step]!==undefined">

        <span v-show="showTones===false">{{ data[step].note }}</span>
        <span v-show="showTones===true">{{ data[step].tone }}</span>
      </span>
    </div>
     <div class="header">{{ header}}</div>


    <div class="clear"></div>
  </div>

</template>

<script>

import {stepColorMapping} from "@shared/helpers/mappings"

export default {
  components: {}, props: {
    data: Object, isScale: Boolean, offset: Number, showTones: Boolean, header:String

  },

  data() {
    return {
      steps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    }
  },

  computed: {

    stepWithOffset() {


      let stepOffset = [this.offset];
      let cont=this.offset;
      for (let i = 0; i < 11; i++) {
        cont = cont+1;
        if (cont>11){
          cont=0;
        }
        stepOffset.push(cont)
      }


      return stepOffset;
    }
  },

  methods: {

    getBackgroundColor(idx, step){
      if (this.isScale === true){
        if (this.data[step]!==undefined) {
          return "whiteBackground"
        }
      }
      else{
         if (this.data[step]!==undefined) {
           return "active color_degree_"+idx;
         }
      }
    }
  }
}
</script>

<style>

.header{
  float:left;
  margin-left: 5px;
  text-align: left;

}
.note_box {
  float: left;
  width: 8.2%;
  max-width: 35px;
  height: 35px;
  opacity: .25;
  -moz-opacity: 0.25;
  -khtml-opacity: 0.25;
  border: 1px solid #222;
  border-radius: 50%;
  color: transparent;

}

.whiteBackground {
  color: #222222!important;
  background-color: white;
    opacity: 1.0!important;
  -moz-opacity: 1.0!important;
  -khtml-opacity: 1.0!important;
}

.active {
  color: #ffffff !important;
  opacity: 1.0;
  -moz-opacity: 1.0;
  -khtml-opacity: 1.0;
}

</style>
